export const mapToCountAndTotal = (
    { count, total, currency }: { count: number, total: number; currency: string; },
): { count: number; total: number; currency: string; } => ({ count, total, currency });
